module.exports = __webpack_public_path__ + "img/marker2.5fa909e1.png";